import { useState } from "react";
import { Alert, Box, Button, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import BlockIcon from "@mui/icons-material/Block";
import { UpgradeModal } from "./UpgradeModal";

interface PlanLimitBannerProps {
  current: number;
  max: number | null;
  label: string;
}

export function PlanLimitBanner({ current, max, label }: PlanLimitBannerProps) {
  const [modalOpen, setModalOpen] = useState(false);

  if (max == null || max <= 0) return null;
  const ratio = current / max;
  if (ratio < 0.8) return null;

  const atLimit = ratio >= 1.0;

  return (
    <>
      <Box sx={{ mb: "var(--sp-4)" }} data-testid={atLimit ? "plan-limit-banner-error" : "plan-limit-banner-warning"}>
        <Alert
          severity={atLimit ? "error" : "warning"}
          icon={atLimit ? <BlockIcon fontSize="inherit" /> : <WarningAmberIcon fontSize="inherit" />}
          // カタログ #19 info-alert(-warning/-error) トークン転写
          sx={{
            py: "var(--sp-3)",
            px: "var(--sp-4)",
            borderRadius: "var(--radius-md)",
            fontSize: "var(--fs-12)",
            backgroundColor: atLimit ? "var(--sem-error-bg)" : "var(--sem-warning-bg)",
            color: atLimit ? "var(--sem-error)" : "var(--sem-warning)",
            alignItems: "center",
            "& .MuiAlert-icon": {
              color: "inherit",
              alignItems: "center",
              mr: "var(--sp-3)",
              p: 0,
            },
            "& .MuiAlert-message": {
              fontSize: "var(--fs-12)",
              color: "inherit",
              p: 0,
              display: "flex",
              alignItems: "center",
            },
            "& .MuiAlert-action": {
              alignItems: "center",
              pt: 0,
              mr: 0,
              p: 0,
            },
          }}
          action={
            <Button
              color="inherit"
              size="small"
              onClick={() => setModalOpen(true)}
              sx={{ fontSize: "var(--fs-11)", whiteSpace: "nowrap" }}
            >
              詳細
            </Button>
          }
        >
          <Typography component="span" sx={{ fontSize: "var(--fs-12)", fontWeight: "var(--fw-semibold)" }}>
            {label}
          </Typography>
          {atLimit
            ? `の登録上限（${max}件）に達しました。新規追加不可。`
            : `の利用数が上限の80%（${current}/${max}件）を超えています。`}
        </Alert>
      </Box>
      <UpgradeModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        resourceLabel={label}
        max={max}
      />
    </>
  );
}
